import {
    ApiHandler,
    createHandlerChainRunner,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { DealerIdParameter, getDealer } from "@mcmc/App/Services/DealerService";

type HandlerType = ApiHandler<DealerIdParameter, string>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { urlSegment: props.parameter.urlSegment };
};

export const SendUrlSegmentToApi: HandlerType = async props => {
    try {
        const result = await getDealer(props.apiParameter);
        props.parameter.onSuccess?.(result);
    } catch (e) {
        props.parameter.onError?.(e && ((e.errorJson && e.errorJson.message) || e.errorMessage || e.message || e));
        return false;
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [PopulateApiParameter, SendUrlSegmentToApi, ExecuteOnSuccessCallback];

const loadDealerId = createHandlerChainRunner(chain, "LoadDealerId");
export default loadDealerId;
